"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _helpers = require("../../helpers");

var _excluded = ["fieldKey", "value", "onChangeRaw", "clearable", "calendar", "disabled", "setBlurAction", "inputFocuc", "manual"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DateInput = function DateInput(props) {
  var fieldKey = props.fieldKey,
      value = props.value,
      onChangeRaw = props.onChangeRaw,
      clearable = props.clearable,
      calendar = props.calendar,
      disabled = props.disabled,
      setBlurAction = props.setBlurAction,
      inputFocuc = props.inputFocuc,
      manual = props.manual,
      restProps = _objectWithoutProperties(props, _excluded);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      val = _useState2[0],
      setVal = _useState2[1];

  var inputRef = (0, _react.useRef)(null);

  var handleClick = function handleClick() {
    return setBlurAction(false);
  };

  var handleChange = function handleChange(ev) {
    var targetValue = ev.target.value;
    setVal(targetValue);
    setBlurAction(true);
    onChangeRaw(targetValue);
  };

  var handleResetValue = function handleResetValue() {
    return onChangeRaw('');
  };

  var handleKeyUp = function handleKeyUp(e) {
    calendar.setOpen(false);

    if (e.keyCode === _helpers.KEY_CODES.ESC) {
      onChangeRaw(value);
    }
  };

  var handleOpenCalendar = function handleOpenCalendar(e) {
    setBlurAction(false);
    e.target.className.indexOf('icon-close') === -1 ? calendar.setOpen(true) : handleResetValue();
  };

  var getClearBtn = function getClearBtn() {
    return clearable ? /*#__PURE__*/_react["default"].createElement("i", {
      className: "icon-close ".concat(fieldKey),
      tabIndex: "0"
    }) : null;
  };

  var getIcons = function getIcons() {
    if (disabled) {
      return null;
    }

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "icon-wrap"
    }, /*#__PURE__*/_react["default"].createElement("i", {
      className: "icon-calendar2 ".concat(fieldKey),
      tabIndex: "0"
    }), getClearBtn());
  };

  (0, _react.useEffect)(function () {
    if (inputFocuc) {
      setBlurAction(true);
      inputRef.current.focus();
      calendar.setOpen(false);
    }
  }, [inputFocuc]);
  (0, _react.useEffect)(function () {
    if (val !== value) setVal(value);
  }, [value]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "datepicker-field-wrap",
    onClick: handleOpenCalendar
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({
    disabled: !manual,
    value: val,
    type: "text"
  }, restProps, {
    onChange: handleChange,
    onKeyUp: handleKeyUp,
    onClick: handleClick,
    ref: inputRef
  })), getIcons());
};

var _default = DateInput;
exports["default"] = _default;
DateInput.propTypes = {
  fieldKey: _propTypes["default"].string,
  value: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  onChangeRaw: _propTypes["default"].func,
  calendar: _propTypes["default"].object,
  setBlurAction: _propTypes["default"].func,
  isClearable: _propTypes["default"].bool,
  inputFocuc: _propTypes["default"].bool,
  manual: _propTypes["default"].bool
};